import React, { Component } from "react";

class Popup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            motivoId: 0,
            esValido: false
        }
        this.validarMotivo = this.validarMotivo.bind(this);
    }

    /**
     * 
     */
    validarMotivo() {
        if (this.state.motivoId == 0 && this.state.validaCambo) {
            this.setState({ esValido: false });
        } else {
            this.props.confirmar((!this.state.validaCambo ? undefined : this.state.motivoId));
        }
    }
    /**
     * 
     */
    componentDidMount() {
        const { clave } = this.props;
        /*lamentablmente necesario para evitar que se cierre el dropdown cuando el usuario hace click sobre el contenido*/
        $(`#${clave} .dropdown-menu`).on({
            "click": function (e) {
                /*si no hay que ejecutar entonces bloqueo la accion*/
                if (e.target.dataset.ejecutar == "true") {
                    /*validar que hacer en caso de ejecutar*/
                    if (e.target.dataset.motivo == "false") {
                        e.stopPropagation();
                    }
                } else {
                    e.stopPropagation();
                }
            }
        });
    }
    /**
     * 
     */
    render() {
        /*Atributos*/
        const { children, clave, motivos, titulo, mensajeError } = this.props;

        return (
            <div className="popup-tarjetas-bloqueo">
                <div className="dropdown" id={clave}>
                    {children}
                    <ul className="dropdown-menu dropdown-menu-right">
                        <div className="top-popup">
                            <li>
                                <label className="label-primary">{titulo}</label>
                            </li>
                           {(this.state.validaCambo && this.state.esValido == false) &&
                                <li className="top-separator-xxs"><label className="error">{mensajeError}</label></li>}

                            <li className="top-separator-xxs">
                                <div className="text-right">
                                    <button type="button"
                                        className="btn btn-cta"
                                        data-ejecutar={true}
                                        data-motivo={(this.state.validaCambo ? this.state.esValido : true)}
                                        onClick={this.validarMotivo}>Listo</button>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Popup;